/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'angular2-qrcode';
export const QRCodeModuleNgFactory:i0.NgModuleFactory<i1.QRCodeModule> = i0.ɵcmf(i1.QRCodeModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,([] as any[])],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(512,
          i1.QRCodeModule,i1.QRCodeModule,([] as any[]))]);
    });
const styles_QRCodeComponent:any[] = ([] as any[]);
export const RenderType_QRCodeComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_QRCodeComponent,data:{}});
export function View_QRCodeComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_QRCodeComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'qr-code',([] as any[]),
      (null as any),(null as any),(null as any),View_QRCodeComponent_0,RenderType_QRCodeComponent)),
      i0.ɵdid(1,573440,(null as any),0,i1.QRCodeComponent,[i0.ElementRef],(null as any),
          (null as any))],(null as any),(null as any));
}
export const QRCodeComponentNgFactory:i0.ComponentFactory<i1.QRCodeComponent> = i0.ɵccf('qr-code',
    i1.QRCodeComponent,View_QRCodeComponent_Host_0,{background:'background',backgroundAlpha:'backgroundAlpha',
        foreground:'foreground',foregroundAlpha:'foregroundAlpha',level:'level',mime:'mime',
        padding:'padding',size:'size',value:'value',canvas:'canvas'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLXFyY29kZS9saWIvYW5ndWxhcjItcXJjb2RlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL0FzeWx1bS9pZGVudGl0eS12YWdyYW50L3NyYy9hc3lsdW0taWRlbmV0aXR5L25vZGVfbW9kdWxlcy9hbmd1bGFyMi1xcmNvZGUvbGliL2FuZ3VsYXIyLXFyY29kZS5kLnRzIiwibmc6Ly8vQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLXFyY29kZS9saWIvYW5ndWxhcjItcXJjb2RlLmQudHMuUVJDb2RlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHFyLWNvZGU+PC9xci1jb2RlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7YUFBQTtVQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/node_modules/angular2-qrcode/lib/angular2-qrcode.ngfactory.ts